export const contactTypes = {
  PHONE: 1,
  CELLPHONE: 2,
  EMAIL: 4,
};

export const serviceOrigin = {
  SERVICE_PLUS: 1,
  MANUAL: 2,
};

export const serviceOriginLabelTable = {
  1: {
    label: 'S+',
    tip: 'Serviços',
  },
  2: {
    label: 'M',
    tip: 'Manual',
  },
};
export const serviceOriginLabelCard = {
  1: 'Serviços +',
  2: 'Manual',
};

export const serviceOriginOptions = [
  {
    id: 1,
    label: 'Serviços +',
  },
  {
    id: 2,
    label: 'Manual',
  },
];

export const serviceType = {
  ELECTRICITY: 1,
  INSURANCES: 2,
  OTHER: 3,
};

export const serviceTypeOptions = [
  {
    id: 1,
    label: 'Energia',
  },
  {
    id: 2,
    label: 'Seguros',
  },
  {
    id: 3,
    label: 'Outros',
  },
];

export const servicePartner = {
  FAST_PATH_COMPANY: 1,
  FAST_PATH_CONDOMINIUM: 2,
  FAST_PATH_WORK_ACCIDENTS: 3,
  IBERDROLA: 4,
  ENDESA: 5,
  LUZIGAS: 6,
  CHARIB_ELECTRICITY: 7,
  CHARIB_INSURANCES: 8,
  MP: 9,
  CLOUDWARE: 10,
  LUSOPAY: 11,
  PORTALPRO: 12,
  NORDSTREET: 13,
  FAST_PATH_HEALTH: 15,
  FAST_PATH_PROFESSIONAL_LIABILITY: 17,
};

export const servicePartnerLabel = {
  1: 'Fast Path',
  2: 'Fast Path',
  3: 'Fast Path',
  4: 'Iberdrola',
  5: 'Endesa',
  6: 'Luzigas',
  7: 'Charib Energia',
  8: 'Charib Seguros',
  9: 'MP',
  10: 'Cloudware',
  11: 'Lusopay',
  12: 'Portal PRO',
  13: 'Nordstreet',
  15: 'Fast Path',
  17: 'Fast Path',
};

export const servicePartnerOptions = [
  {
    id: 1,
    label: 'Fast Path empresa',
    typeId: serviceType.INSURANCES,
  },
  {
    id: 2,
    label: 'Fast Path condomínio',
    typeId: serviceType.INSURANCES,
  },
  {
    id: 3,
    label: 'Fast Path acidentes de trabalho',
    typeId: serviceType.INSURANCES,
  },
  {
    id: 4,
    label: 'Iberdrola',
    typeId: serviceType.ELECTRICITY,
  },
  {
    id: 5,
    label: 'Endesa',
    typeId: serviceType.ELECTRICITY,
  },
  {
    id: 6,
    label: 'Luzigas',
    typeId: serviceType.ELECTRICITY,
  },
  {
    id: 7,
    label: 'Charib Seguros',
    typeId: serviceType.INSURANCES,
  },
  {
    id: 9,
    label: 'MP',
    typeId: serviceType.OTHER,
  },
  {
    id: 10,
    label: 'Cloudware',
    typeId: serviceType.OTHER,
  },
  {
    id: 11,
    label: 'Lusopay',
    typeId: serviceType.OTHER,
  },
  {
    id: 12,
    label: 'Portal PRO',
    typeId: serviceType.OTHER,
  },
  {
    id: 13,
    label: 'Nordstreet',
    typeId: serviceType.OTHER,
  },
  {
    id: 15,
    label: 'Fast Path seguro saúde',
    typeId: serviceType.INSURANCES,
  },
  {
    id: 17,
    label: 'Fast Path responsabilidade civil profissional',
    typeId: serviceType.INSURANCES,
  },
];

export const CTALogStatusOptions = [
  { id: 1, name: 'Ativo' },
  { id: 2, name: 'Inativo' },
];

export const ApplicationOptions = [
  { id: 1, name: 'Gecond' },
  { id: 2, name: 'Gesar' },
  { id: 3, name: 'Gimob' },
  { id: 4, name: 'Comum' },
];
